"use client";

import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { useEnvContext } from "next-runtime-env";

import {
  WishlistProductsPageResponse,
  getWishlistProductsPageQueryOptions,
} from "../api/wishlist.query";

type Props = {
  page: number;
  enabled: boolean;
};

export function usePaginatedWishlistResults({ page, enabled }: Props) {
  const { NEXT_PUBLIC_BFF_API } = useEnvContext();
  const locale = useLocale();

  const query = useQuery<WishlistProductsPageResponse>({
    ...getWishlistProductsPageQueryOptions({
      apiOrigin: NEXT_PUBLIC_BFF_API!,
      locale,
      page,
    }),
    placeholderData: (prev) => prev,
    enabled,
  });

  const products = query.data?.products ?? [];
  const totalPages = query.data?.pagination.total_pages ?? 0;
  const isLoading =
    query.isLoading || query.isPending || query.isPlaceholderData;
  const isLastPage = !isLoading && totalPages > 0 && page === totalPages;

  return {
    products,
    isLoading,
    isLastPage,
    totalPages,
    loadMoreProducts: undefined,
    isFetchingMore: false,
  };
}
